import api from 'api/client';
import { ENDPOINTS } from 'api/endpoints';
import { StoreAdminDashboard, StoreDashboardDays, StoreOperationCounts } from 'types/admin';

export const OPERATION_COUNTS_REFRESH = 'eone-admin-operation-counts';

export const requestOperationCountsRefresh = () => {
  window.dispatchEvent(new Event(OPERATION_COUNTS_REFRESH));
};

const dashboardAdminService = {
  get: async (days: StoreDashboardDays): Promise<StoreAdminDashboard> => {
    const { data } = await api.get<StoreAdminDashboard>(ENDPOINTS.ADMIN_DASHBOARD, { params: { days } });
    return data;
  },

  getOperationCounts: async (): Promise<StoreOperationCounts> => {
    try {
      const { data } = await api.get<StoreOperationCounts>(ENDPOINTS.ADMIN_OPERATION_COUNTS);
      return {
        abandonedCarts: data.abandonedCarts ?? 0,
        pendingAccessRequests: data.pendingAccessRequests ?? 0,
      };
    } catch (err: unknown) {
      const status = (err as { response?: { status?: number } }).response?.status;
      if (status !== 404) throw err;
    }

    const { data } = await api.get<StoreAdminDashboard>(ENDPOINTS.ADMIN_DASHBOARD, { params: { days: 30 } });
    return {
      abandonedCarts: data.abandonedCarts?.count ?? 0,
      pendingAccessRequests: data.operations?.pendingAccessRequests ?? 0,
    };
  },
};

export default dashboardAdminService;
